export enum EExceptionToPolicyTypes {
  NONE = 'none',
  AGE = 'Age',
  MORAL = 'Moral',
  TFC = 'TFC',
  EXCEPTION_785 = '785',
  MEDICAL = 'Medical',
  OTHER = 'Other'
}
